import _ from 'underscore';
import type { DependantsMap, EntityName, EntityNameInput } from './types';

/* eslint-disable max-len */

const deps: DependantsMap = {};

function addDependency(from: EntityName, to: EntityName) {
  deps[to] = deps[to] || [];
  deps[to].push(from);
}

function addDependencies(from: EntityNameInput, to: EntityNameInput) {
  const [fromArr, toArr] = [from, to].map(o => (_.isArray(o) ? o : [o]));
  _.each(fromArr, f => _.each(toArr, t => addDependency(f, t)));
}

// addDependencies(EntityA, EntityB) means:
//   as long as EntityB is changed, invalidate the cache for EntityA

// Start adding dependencies
addDependencies(['AdGroup', 'CampaignCriterion', 'Enum.CampaignType', 'NegativeCampaignDsaTarget', 'CampaignNegativeWebpage', 'FeedAssociation', 'SharedEntityAssociation'], 'Campaign');
addDependencies(['Keyword', 'Ad', 'CampaignCriterion', 'DsaTarget', 'NegativeAdGroupDsaTarget', 'AudienceAssociation'], 'AdGroup');
addDependencies(['Campaign', 'AdGroupCriterion'], 'CampaignCriterion');
addDependencies('Campaign', 'ShoppingCampaign'); // ShoppingCampaign is a "dynamic"/"virtual" subclass of Campaign
addDependencies('NegativeKeyword', ['CampaignNegativeKeyword', 'AdGroupNegativeKeyword', 'SearchTerm']);
addDependencies(['Campaign', 'PerformanceTargetInstance', 'PerformanceTimeSeries'], 'PerformanceTarget');
addDependencies(['Campaign', 'AdGroup', 'Keyword', 'NegativeKeyword', 'Ad', 'CampaignCriterion', 'AdGroupCriterion'], 'Experiment');
addDependencies('AssetLink', 'Ad');
addDependencies('Campaign', 'SeasonalityAdjustment');
addDependencies('SearchTerm', ['Keyword', 'NegativeKeyword', 'CampaignNegativeKeyword', 'AdGroupNegativeKeyword']);
addDependencies(['Account', 'Campaign', 'AdGroup', 'Ad', 'AutomatedExtension', 'AdExtensionAssociation', 'Keyword', 'SearchTerm'], 'CustomColumn');
addDependencies(['Campaign', 'AdGroup', 'Keyword', 'Ad'], 'AdCustomizerAttribute');
addDependencies(['Campaign', 'ProductListingGroup', 'AudienceAssociation', 'AssetLink', 'AssetGroupInstance', 'AudienceGroup'], 'AssetGroup');
addDependencies('AssetGroup', 'AudienceGroup');
addDependencies(['Campaign', 'ConversionGoalDetails'], 'Goal');
addDependencies(['FeedAssociation'], 'Feed');

// If PortfolioBidStrategy is created / renamed, need to invalidate Campaign cache, otherwise bid strategy name in campaign grid is incorrect.
addDependencies('Campaign', 'PortfolioBidStrategy');
// If Campaign is deleted, need to invalidate PortfolioBidStrategy cache, otherwise the associated campaigns count in portfolio grid is incorrect.
// If Campaign is imported, need to invalidate PortfolioBidStrategy cache, otherwise imported PortfolioBidStrategy does not show.
addDependencies('PortfolioBidStrategy', 'Campaign');

// Mutual dependency between Ad and its subclasses
const adTypes: EntityName[] = [
  'TextAd',
  'MobileAd',
  'ProductAd',
  'AppInstallAd',
  'DynamicSearchAd',
  'ExpandedTextAd',
  'ResponsiveAd',
  'ResponsiveSearchAd',
  'HotelAd',
];
addDependencies('Ad', adTypes);
addDependencies(adTypes, 'Ad');
// End adding dependencies

export const dependants: DependantsMap = _.mapObject(deps, d => _.uniq(d));
